export default __webpack_public_path__ + "static/media/image13.f90ddc75.jpg";